import React from "react";
// import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Fichier from "../components/FichierActions";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Fichier Actions" />

        {/* UsersListLayer */}
        <Fichier />

      {/* </MasterLayout> */}

    </>
  );
};

export default UsersListPage; 
